// extracted by mini-css-extract-plugin
export default {"component":"SkeletonStyles_component__YZkTD","gradient-animation":"SkeletonStyles_gradient-animation__fnbPg","placeHolderBg":"SkeletonStyles_placeHolderBg__loVBB"};